<template>
    <button 
      @click="handleClick"
      class="w-full h-[48px] bg-[#00423D] text-white font-semibold text-[16px] leading-[24px] rounded-[12px] px-6 py-3"
      style="font-family: 'Open Sans'; font-weight: 600;"
    >
      {{ text }}
    </button>
  </template>
  
  <script setup>
  import { useRouter } from 'vue-router';
  import { defineProps } from 'vue';
  import { useOnboardingStore } from '@/stores/onboarding';
  
  const router = useRouter();
  const onboardingStore = useOnboardingStore();
  
  const props = defineProps({
    text: String,
    nextRoute: String,
    validateForm: Boolean,
    v$: Object,
    form: Object
  });
  
  const handleClick = async () => {
    if (props.validateForm && props.v$) {
      props.v$.$touch();
  
      if (props.v$.$invalid) {
        console.log("Form has errors", props.v$.$errors);
        return;
      }
    }
  
    // Get current and next route paths
    const currentPath = router.currentRoute.value.path;
    const nextPath = `/onboarding/${props.nextRoute}`;
  
    // Only update status for onboarding routes
    if (currentPath.includes('/onboarding/')) {
      // Update both current and next route statuses at once
      await onboardingStore.batchUpdateRouteStatus({
        updates: [
          { routeName: currentPath, newRouteState: 1 },
          { routeName: nextPath, newRouteState: 0 }
        ]
      });
    }
  
    router.push({ name: props.nextRoute });
  };
  </script>
  